import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ImageWrapper } from "./PixelIcon.styles";
import { iconDefinitions } from "./pixelIconDefinitions";
var PixelIcon = function(param) {
    var hasMarginRight = param.hasMarginRight, height = param.height, name = param.name, label = param.label, width = param.width;
    var iconDefinition = iconDefinitions[name];
    return iconDefinition && /*#__PURE__*/ _jsx(ImageWrapper, {
        hasMarginRight: hasMarginRight,
        w: width,
        h: height,
        children: /*#__PURE__*/ _jsx("img", {
            src: iconDefinition.src,
            alt: label || "",
            width: iconDefinition.width,
            height: iconDefinition.height
        })
    });
};
export { PixelIcon };
